import { render } from "./index.vue?vue&type=template&id=a05e6ac2&scoped=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a05e6ac2&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a05e6ac2"]])

export default __exports__